<template>
  <div class="ai-image f-c-c">
    <div v-if="status === 'In Complete'" ref="aiImage" class="complete" @mouseenter="mouseenter" @mouseleave="mouseleave">
      <oss-img :width="300" :height="300" :src="aiPicture.oosUrl" mType="pad" />
      <div class="hover" v-if="hoverImg" @click.self="dialogVisible = true">
        <div class="seed">Seed: {{ aiPicture.pngInfo.seed }}</div>
        <div class="handle f--c">
          <el-tooltip effect="dark" content="Customize" placement="bottom">
            <div @click="handleCustomize">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_453_15473)"><path id="Vector" d="M6.3345 2.66699L9.3345 5.33366L12.6786 3.37026L11.0012 7.00032L14.0012 9.66699L10.0012 9.33366L8.50117 12.667L7.66784 9.00032L3.66797 8.66699L7.17057 6.55032L6.3345 2.66699Z" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_2" d="M2.66797 14.0068L7.66797 9" stroke="#909399" stroke-width="1.33333" stroke-linecap="round"/></g><defs><clipPath id="clip0_453_15473"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>
            </div>
          </el-tooltip>
          <el-tooltip effect="dark" content="View Larger Image" placement="bottom">
            <div @click="dialogVisible = true">
              <!-- <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_441_6301)"><path d="M13 2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2Z" stroke="#909399" stroke-width="1.33333" stroke-linejoin="round"/><path d="M2 9.33319L5.56437 6.06586C5.81297 5.83796 6.19263 5.83163 6.4487 6.05113L10.6667 9.66653" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.33203 7.99979L10.9232 6.40862C11.1578 6.17406 11.5292 6.14766 11.7946 6.34672L13.9987 7.99979" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M2 6.6665V9.99984" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 6.6665V9.99984" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_441_6301"><rect width="16" height="16" fill="white"/></clipPath></defs></svg> -->
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path id="Vector" d="M11 2H14V5" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_2" d="M14 11V14H11" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_3" d="M5 14H2V11" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_4" d="M2 5V2H5" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></g></svg>
            </div>
          </el-tooltip>
          <el-tooltip effect="dark" content="Download" placement="bottom">
            <div @click="handleDownload">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_453_15493)"><g><path id="Vector" d="M2 8.00277V14H14V8" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_2" d="M11 7.66699L8 10.667L5 7.66699" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_3" d="M7.99609 2V10.6667" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></g></g><defs><clipPath id="clip0_453_15493"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>
            </div>
          </el-tooltip>
            <el-tooltip effect="dark" content="Delete" placement="bottom">
              <div @click="handleDelete">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_453_15485)"><path id="Vector" d="M3 3.33301V14.6663H13V3.33301H3Z" stroke="#909399" stroke-width="1.33333" stroke-linejoin="round"/><path id="Vector_2" d="M6.66797 6.66699V11.0003" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_3" d="M9.33203 6.66699V11.0003" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_4" d="M1.33203 3.33301H14.6654" stroke="#909399" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_5" d="M5.33203 3.33301L6.42836 1.33301H9.59106L10.6654 3.33301H5.33203Z" stroke="#909399" stroke-width="1.33333" stroke-linejoin="round"/></g><defs><clipPath id="clip0_453_15485"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>
              </div>
            </el-tooltip>
        </div>
      </div>
    </div>
    <div v-if="status === 'IN INTERRUPT'" class="stop">
      <img src="https://img.kakaclo.com/web-img/home/ai/icon_warning.png" alt="">
      <div>AI generation failed</div>
    </div>
    <div v-if="status === 'In Progress'" class="progress">
      <!-- <img src="https://img.kakaclo.com/web-img/home/ai/loading.png" alt=""> -->
      <div class="animation2">
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
			</div>
      <div>AI generating...</div>
    </div>
    <div v-if="status === 'In Waiting'" class="waiting">
      <div class="animation1"></div>
      <div>Waiting to generate...</div>
    </div>

    <el-dialog ref="dialog" title="Seed: 1230239049" :visible.sync="dialogVisible" class="dialog" top="6vh" width="880px">
      <img style="width:100%" :src="aiPicture.oosUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import OssImg from '../../../../components/OssImg.vue'
export default {
  components: { OssImg },
  props: {
    status: {
      type: String, // In Progress:生成中, In Waiting：等待中, In Complete:完成, IN INTERRUPT:已停止
      default: 'Waiting'
    },
    aiPicture: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      hoverImg: false,
      dialogVisible: false
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    mouseenter() {
      this.hoverImg = true
    },
    mouseleave() {
      this.hoverImg = false
    },
    handleDownload() {
      window.open(this.aiPicture.oosUrl)
    },
    handleDelete() {
      this.$emit('handleDelete', this.index)
    },
    handleCustomize() {
      this.$emit('handleCustomize', this.aiPicture.oosUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-image {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #F7F8FB;
  border: 1px solid #E1E4EA;
  border-radius: 2px;

  .complete {
    width: 100%;
    height: 100%;
    position: relative;
    >img {
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }
    .hover {
      cursor: pointer;
      position: absolute;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      background: rgba(0, 0, 0, .5);
      top: 0;
      left: 0;

      .seed {
        position: absolute;
        top: 12px;
        left: 12px;
        color: #fff;
        font-size: 14px;
        cursor: text
      }

      .handle {
        position: absolute;
        bottom: 12px;
        right: 12px;
        background-color: #fff;
        border-radius: 2px;
        overflow: hidden;

        >div, .el-tooltip {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 28px;
          box-sizing: border-box;
          border-right: 1px solid #E1E4EA;
          cursor: pointer;
          &:last-child {
            border: 0;
          }
        }
        >div:hover {
          /deep/ svg path {
            stroke: #9AC331
          }
        }
      }
    }
  }

  .stop, .progress, .waiting {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    img {
      width: 48px;
      height: 48px;
      margin-bottom: 8px;
    }

    div {
      color: #C0C4CC;
      font-size: 14px;
    }
  }

  .dialog {
    /deep/ .el-dialog__body {
      padding: 20px;
      padding-top: 10px;
    }
  }

  .animation1 {
    display:inline-block;
    margin-bottom: 20px;
    width: 0;
    height:0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid #909399;
    border-top: 15px solid #C0C4CC;
    -webkit-animation: animation1 2.5s ease-in-out infinite alternate;
    animation: animation1 2.5s ease-in-out infinite alternate;
  }

  .animation2 {
    display:inline-block;
    font-size:0px;
    padding:0px;
    margin-bottom: 15px;
    span {
      border-radius:100%;
      display:inline-block;
      width:10px;
      height:10px;
      margin:3px 2px;
      -webkit-animation:animation2 0.8s linear infinite alternate;
      animation:animation2 0.8s linear infinite alternate;
      &:nth-child(1) {
        -webkit-animation-delay:-1s;
        animation-delay:-1s;
        // background:rgba(245, 103, 115,0.6);
        background:rgba($color: #909399, $alpha: .6);
      }
      &:nth-child(2) {
        -webkit-animation-delay:-0.8s;
        animation-delay:-0.8s;
        // background:rgba(245, 103, 115,0.8);
        background:rgba($color: #909399, $alpha: .8);
      }
      &:nth-child(3) {
        -webkit-animation-delay:-0.26666s;
        animation-delay:-0.26666s;
        // background:rgba(245, 103, 115,1);
        background:rgba($color: #909399, $alpha: 1);
      }
      &:nth-child(4) {
        -webkit-animation-delay:-0.8s;
        animation-delay:-0.8s;
        // background:rgba(245, 103, 115,0.8);
        background:rgba($color: #909399, $alpha: .8);
      }
      &:nth-child(5) {
        -webkit-animation-delay:-1s;
        animation-delay:-1s;
        // background:rgba(245, 103, 115,0.4);
        background:rgba($color: #909399, $alpha: .4);
      }
    }
  }

  @keyframes animation1 {
    from {transform: rotate(0deg);}
    to {transform: rotate(720deg);}
  }
  @-webkit-keyframes animation1 {
    from {-webkit-transform: rotate(0deg);}
    to {-webkit-transform: rotate(720deg);}
  }

  @keyframes animation2 {
    from {transform: scale(0, 0);}
    to {transform: scale(1, 1);}
  }
  @-webkit-keyframes animation2 {
    from {-webkit-transform: scale(0, 0);}
    to {-webkit-transform: scale(1, 1);}
  }
}

</style>
